/**
 * v-click-outside
 * @description 点击元素外部触发某些操作的指令
 * @example
 * <div v-click-outside="handleClickOutside">点击我外部触发handleClickOutside</div>
 */
import type { Directive, DirectiveBinding } from 'vue'

type HTMLElementExpandType = HTMLElement & {
  __clickOutside__: (...args: any[]) => void
}

const clickOutside: Directive = {
  beforeMount(el: HTMLElementExpandType, binding: DirectiveBinding) {
    el.__clickOutside__ = (event: MouseEvent) => {
      if (!(el === event.target || el.contains(event.target as Node))) {
        binding.value(event)
      }
    }
    document.body.addEventListener('click', el.__clickOutside__)
  },
  beforeUnmount(el: HTMLElementExpandType) {
    document.removeEventListener('click', el.__clickOutside__)
  }
}

export default clickOutside
